<div style="padding: 5% 10%;">
    <div class="row">
        <div class="col-md-11">
            <label class="label-title">Cambiar contraseña</label>
        </div>
        <div class="col-md-1">
            <mat-icon class="material-icon-round" style="color:red; cursor: pointer; "
                (click)="close()">close</mat-icon>
        </div>
    </div>


    <input class="login-input" name="Email" type="email" placeholder="Digite su correo electrónico"
        [(ngModel)]="passwordObj.Email" required disabled />
    <input class="login-input" name="Password" type="password" placeholder="Digite contraseña anterior"
        [(ngModel)]="passwordObj.oldPassword" required />
    <input class="login-input" name="NewPassword" type="password" placeholder="Digite nueva contraseña"
        [(ngModel)]="passwordObj.NewPassword" required />
    <input class="login-input" name="NewPasswordCopy" type="password" placeholder="Confirme nueva contraseña" required
        [(ngModel)]="newPasswordCopy" />
    <div class="row">
        <div class="col-md-12" style="text-align: center;">
            <button class="button btn_naranja mt-4" (click)="submitChangePassword()">Continuar</button>
        </div>
    </div>
</div>